@if (hasSearchTerm()) {
  @if (activeTab() && activeTab()?.entityType !== "all") {
    @if (currentEntity(); as currentEntity) {
      @if (currentEntity.values?.length) {
        <procure-search-result-list
          [label]="currentEntity.entityType"
          [badge]="currentEntity.values.length"
          [values]="currentEntity.values"
        />
      } @else {
        <div class="empty">No results found</div>
      }
      @if (currentEntity.count && currentEntity.values && currentEntity.count > currentEntity.values.length) {
        <button
          class="show-more"
          procure-button
          (click)="showMore()"
        >
          Show more
        </button>
      }
    }
  } @else {
    @if (data().length) {
      @for (entity of data(); track entity.entityType) {
        <procure-search-result-list
          [label]="entity.entityType"
          [badge]="entity.values?.length"
          [values]="entity.values"
        />
      }
    } @else {
      <div class="empty">No results found</div>
    }
  }
} @else {
  @if (hasDefaultData()) {
    @if (recentlyVisitedEntities().length) {
      <procure-search-result-list
        label="Recently viewed"
        [badge]="recentlyVisitedEntities().length"
        [values]="recentlyVisitedEntities()"
        [showDetail]="false"
      />
      <a
        class="show-more"
        procure-button
        [routerLink]="['/recent']"
        (click)="hideSearch()"
      >
        Show more
      </a>
    }
    @if (favoriteEntities().length) {
      <procure-search-result-list
        label="Favorites"
        [badge]="favoriteEntities().length"
        [values]="favoriteEntities()"
        [showDetail]="false"
      />
      <a
        class="show-more"
        procure-button
        [routerLink]="['/favorite']"
        (click)="hideSearch()"
      >
        Show more
      </a>
    }
  } @else {
    <div class="empty">No results found</div>
  }
}
